import { FormattedMessage } from "react-intl"
import VideoCallCard from "../VideoCallCard/VideoCallCard";
import { VideoCallOutput } from "graphql/communicate/videocall/VideoCall.types";

type VideoCallsListProps = {
  videoCalls: VideoCallOutput[];
}

const VideoCallsList = ({ videoCalls }: VideoCallsListProps): JSX.Element => {
  const sortedVideoCalls = videoCalls ? [...videoCalls]?.sort((videoCallA, videoCallB) => videoCallB.created - videoCallA.created) : undefined;
  return  <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-2w p-2w min-h-[200px] w-full rounded-2xl bg-classic-violet-light'>
            {sortedVideoCalls && sortedVideoCalls.length > 0 ? 
                sortedVideoCalls
                  .map(videoCall => <VideoCallCard key={videoCall.roomName}
                                                          date={new Date(videoCall.created)} 
                                                          participants={videoCall.participantEmails.map(email => ({ email }))} 
                                                          videoCallCreator={videoCall.creatorFullName} 
                                                          videoCallLink={videoCall.roomName} />) :
              <div className='col-start-2 flex justify-center items-center w-full'>
                <span className="text-header6 text-white">
                  <FormattedMessage id='videoCall.home.videoCallList.noVideoCall'></FormattedMessage>
                </span>
              </div>
            }
          </div>
}

export default VideoCallsList;